import "core-js/modules/es.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import conditionCreator from '../conditionCreator';
export default {
  components: {
    conditionCreator: conditionCreator
  },
  props: {
    gradeList: {
      type: Array
    },
    levelList: {
      type: Array
    }
  },
  data: function data() {
    return {
      name: '',
      row: null,
      dialogVisible: false,
      exaCond: [],
      exaActionSelect: '-1',
      exaAction: {
        name: '无作用',
        tag: '-1',
        params: []
      },
      exaActionList: [{
        name: '无作用',
        tag: '-1',
        params: []
      }, {
        name: '保级(审核不通过就会降级，头衔不变)',
        tag: 'exa_relegation',
        params: [{
          name: '降到指定级别',
          value: '',
          type: 'grade'
        }]
      }]
    };
  },
  mounted: function mounted() {},
  methods: {
    onClose: function onClose() {
      this.finish();
    },
    show: function show(row, finish) {
      var _this = this;

      this.row = row;
      this.name = row.name;

      if (this.row.exaAction && this.row.exaAction !== '') {
        this.exaAction = this.$tempModel.deepCopy(this.row.exaAction);
        this.exaActionSelect = this.exaAction.tag;
      }

      if (this.row.exaCond && this.row.exaCond !== '') {
        this.exaCond = this.$tempModel.deepCopy(this.row.exaCond);
      }

      this.dialogVisible = true;
      this.finish = finish;
      this.$nextTick(function () {
        _this.$refs.creator.setCondData(_this.$tempModel.deepCopy(_this.exaCond));
      });
    },
    exaActionChange: function exaActionChange(value) {
      for (var i in this.exaActionList) {
        var item = this.exaActionList[i];

        if (item.tag === value) {
          this.exaAction = this.$tempModel.deepCopy(item);

          for (var _i in this.exaAction.params) {
            var _item = this.exaAction.params[_i];

            if (_item.type === 'grade') {
              if (this.gradeList.length > 0) {
                _item.value = this.gradeList[0].tag;
              }
            }
          }

          break;
        }
      }
    },
    clickSubmit: function clickSubmit() {
      this.row.exaCond = this.$refs.creator.getCondData();
      this.row.exaAction = this.exaAction;
      this.dialogVisible = false;
      this.finish();
    }
  }
};